import CalculatorAgent from "../views/CalculatorAgent.vue";
import CalculatorReport from "../views/calcagent/CalcResultWindow.vue";


const menu = [
  {title: "Калькулятор", icon: "fa fa-calculator", url: "/calcagent", id: 2},
]

const routes = [
    {
      path: "/calcagent",
      name: "calcagent",
      component: CalculatorAgent,
      meta: {
        forAuth: true
      }
    },
    {
      path: "/calcreport",
      name: "calcreport",
      component: CalculatorReport,
      meta: {
        forAuth: true
      }
    },
  ]

  export default {menu,routes}
